import { render, staticRenderFns } from "./action_params_gift.vue?vue&type=template&id=0d5fe80c&scoped=true&"
import script from "./action_params_gift.vue?vue&type=script&lang=js&"
export * from "./action_params_gift.vue?vue&type=script&lang=js&"
import style0 from "./action_params_gift.vue?vue&type=style&index=0&id=0d5fe80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5fe80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5fe80c')) {
      api.createRecord('0d5fe80c', component.options)
    } else {
      api.reload('0d5fe80c', component.options)
    }
    module.hot.accept("./action_params_gift.vue?vue&type=template&id=0d5fe80c&scoped=true&", function () {
      api.rerender('0d5fe80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/modal/tabs/action_params_gift.vue"
export default component.exports